import { render, staticRenderFns } from "./GBHeader.vue?vue&type=template&id=f2923b90&scoped=true&"
import script from "./GBHeader.vue?vue&type=script&lang=js&"
export * from "./GBHeader.vue?vue&type=script&lang=js&"
import style0 from "./GBHeader.vue?vue&type=style&index=0&id=f2923b90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2923b90",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/ganttboard/project/ganttboard-frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VBtnToggle } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarItems } from 'vuetify/lib'
installComponents(component, {VBtn,VBtnToggle,VDatePicker,VDivider,VIcon,VLayout,VMenu,VSpacer,VToolbar,VToolbarItems})
